import { render, staticRenderFns } from "./TrashBankBranch.vue?vue&type=template&id=330e0f0a&"
import script from "./TrashBankBranch.vue?vue&type=script&lang=js&"
export * from "./TrashBankBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports